import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // for navigation
import "./css/LanguageSelection.css";
import logoImage from "../assets/images/logo.png";
import languageIcon from "../assets/icons/language.png";
import ukFlag from "../assets/icons/uk.png";
import uaeFlag from "../assets/icons/uae.png";

function LanguageSelection() {
  const [selected, setSelected] = useState("en");
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Check authentication status
  //   const appLanguage = localStorage.getItem("app_language");

  //   // Redirect if authenticated
  //   if (appLanguage) {
  //     navigate("/onboarding", { replace: true });
  //   }
  // }, [navigate]);

  const handleContinue = () => {
    // Save selected language to localStorage
    localStorage.setItem("app_language", selected);

    // (Optional) Redirect to next screen
    navigate("/onboarding"); // change path as needed (or remove this line if not needed)
  };

  return (
    <div className="common-wrapper">
      <div className="logo-container">
        <img src={logoImage} alt="Logo" className="page-logo" />
      </div>
      <div className="top-section">
        <img src={languageIcon} alt="Language" className="language-icon" />

        <h2 className="title">Language Selection</h2>
        <p className="subtitle">Choose your preferred one</p>

        <div className="language-options">
          <div
            className={`option-box ${selected === "en" ? "active" : ""}`}
            onClick={() => setSelected("en")}
          >
            <div className="d-flex align-items-center">
              <input
                type="radio"
                name="language"
                checked={selected === "en"}
                readOnly
              />
              <img src={ukFlag} alt="English" className="flag" />
              <span>English</span>
            </div>
          </div>

          <div
            className={`option-box ${selected === "ar" ? "active" : ""}`}
            onClick={() => setSelected("ar")}
          >
            <div className="d-flex align-items-center">
              <input
                type="radio"
                name="language"
                checked={selected === "ar"}
                readOnly
              />
              <img src={uaeFlag} alt="Arabic" className="flag" />
              <span>Arabic</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-section">
        <button className="continue-btn w-100" onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default LanguageSelection;